/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';
import { Badge } from 'dibs-elements/exports/Badge';
import get from 'lodash.get';

import { getIsFreeShipping } from '../../helpers/freeShippingHelpers';

import styles from './styles.scss';

import type { Shipping_item as ItemProp } from './__generated__/Shipping_item.graphql';
import type { Shipping_viewer as ViewerProp } from './__generated__/Shipping_viewer.graphql';

type Props = {|
    currency: string,
    item: ItemProp,
    viewer: ViewerProp,
|};

function ShippingBadgeComponent({ item, viewer }: Props) {
    const userRegions = get(viewer, 'regionalInfo[0].regionsByZipCode') || [];
    const isFreeRegionalShipping = getIsFreeShipping({ item, userRegions });

    if (!isFreeRegionalShipping) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Badge>
                <span className={styles.label} data-tn="free-shipping">
                    <FormattedMessage
                        id="dc.searchProductTile.freeShipping"
                        defaultMessage="FREE SHIPPING"
                    />
                </span>
            </Badge>
        </div>
    );
}

export const ShippingBadge = createFragmentContainer(ShippingBadgeComponent, {
    viewer: graphql`
        fragment Shipping_viewer on Viewer
            @argumentDefinitions(
                fetchRegionalInfo: { type: "Boolean", defaultValue: false }
                userZipCode: { type: "String", defaultValue: "0" }
                userCountryCode: { type: "String", defaultValue: "" }
            ) {
            regionalInfo(zipCode: $userZipCode, countryCode: $userCountryCode)
                @include(if: $fetchRegionalInfo) {
                regionsByZipCode {
                    displayName
                }
            }
        }
    `,
    item: graphql`
        fragment Shipping_item on Item {
            vertical
            shipmentQuotes {
                totalAmount {
                    amount
                }
                serviceMethod {
                    region {
                        regionName
                    }
                }
            }
        }
    `,
});
